import { Module } from 'vuex-smart-module';
import LastNotificationsActions from './actions';
import LastNotificationsGetters from './getters';
import LastNotificationsMutations from './mutations';
import LastNotificationsState from './state';

export default new Module({
  state: LastNotificationsState,
  mutations: LastNotificationsMutations,
  actions: LastNotificationsActions,
  getters: LastNotificationsGetters,
});
